import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router-dom'
import { useEffect, useState, type FC } from 'react'
import { SpinnerLoader } from 'shared/ui'
import {
  type EnumAccessPageKeys,
  promiseCheckAccessPage,
  checkAccessPage,
} from 'entities/ExportRouters/lib/checkAccessPage'
import { useEntitiesContext } from 'entities/EntitiesExport'

type IAccessLayoutProps = {
  name: EnumAccessPageKeys
  onAccessDenied?: () => void
  onAccessSuccess?: () => void
  isDisableContent?: boolean
}

export const AccessLayout: FC<IAccessLayoutProps> = observer(
  ({ name, onAccessDenied, onAccessSuccess, isDisableContent }) => {
    const [loading, setLoading] = useState<boolean | null>(true)
    const [initialized, setInitialized] = useState(false)
    const entities = useEntitiesContext()

    const hasAccess = checkAccessPage(name, entities)

    useEffect(() => {
      promiseCheckAccessPage(name, entities).then((hasAccessPage) => {
        const canNotAccess = !hasAccessPage

        if (canNotAccess) {
          onAccessDenied?.()
          setLoading(null)
        } else {
          onAccessSuccess?.()
          setLoading(false)
          setInitialized(true)
        }
      })
    }, [])

    useEffect(() => {
      if (!initialized) return
      if (!hasAccess) {
        onAccessDenied?.()
      }
    }, [hasAccess, initialized])

    if (!isDisableContent && loading === null) return <>Access denied</>

    if (loading) return <SpinnerLoader ariaLabel={'AccessLayout'} />

    if (initialized && !hasAccess) return null

    return (
      <>
        <Outlet />
      </>
    )
  }
)
